import { render } from "./PermissionTest.vue?vue&type=template&id=bfd9e8f6&scoped=true"
import script from "./PermissionTest.vue?vue&type=script&lang=js"
export * from "./PermissionTest.vue?vue&type=script&lang=js"

import "./PermissionTest.vue?vue&type=style&index=0&id=bfd9e8f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd9e8f6"]])

export default __exports__